<template>
  <div>
      <router-view></router-view>
  </div>
</template>

<script>

export default {
  name: 'defaultLayout',
  data () {
    return {
    }
  },
  created () {
  },
  components: {
  }
}
</script>




// WEBPACK FOOTER //
// DefaultLayout.vue?584e560b